import React from 'react';
import SEO from '../../components/SEO';
import { motion } from 'framer-motion';
import PageBanner from '../../components/PageBanner';

const ResearchDevelopmentPage = () => {
    const fadeIn = {
        initial: { opacity: 0, y: 30 },
        whileInView: { opacity: 1, y: 0 },
        viewport: { once: true },
        transition: { duration: 0.8 }
    };

    return (
        <div className="bg-white min-h-screen pt-20 lg:pt-[120px] font-sans">
            <SEO
                title="BAIC R&D | Research & Development Innovation"
                description="BAIC's Research & Development excellence. Pioneering New Energy Vehicles, Smart Connectivity, and Magic Core Power technology."
                canonicalUrl="https://baicoman.com/about/research-development"
            />
            <h1 className="sr-only">BAIC Research and Development (R&D)</h1>
            {/* Hero Section */}
            {/* Hero Section */}
            <PageBanner
                image="/assets/images/research-development/686_1718787205research-development-page-heading.png"
                imageAlt="Research and Development"
            >
                <div className="w-full flex items-center">
                    <motion.div
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h2 className="text-3xl md:text-7xl font-bold text-white uppercase mb-4 leading-tight">
                            Research &<br />Development
                        </h2>
                    </motion.div>
                </div>
            </PageBanner>

            {/* New Energy Vehicle Innovation */}
            <section className="bg-gray-900 text-white py-24 overflow-hidden relative">
                <img src="/assets/images/research-development/bg-distributor-vehicle.D5nIHpKh.png" alt="Tech BG" className="absolute right-0 top-0 h-full w-2/3 object-cover opacity-30" />
                <div className="max-w-7xl mx-auto px-4 relative z-10 flex flex-col md:flex-row items-center">
                    <motion.div className="md:w-1/2" {...fadeIn}>
                        <h2 className="text-4xl md:text-5xl font-bold mb-6">New Energy<br />Vehicle<br />Innovation</h2>
                        <p className="text-gray-300 text-lg max-w-md">
                            Exploring the future of mobility with cutting-edge sustainable technologies and platform architectures.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* Smart Connection Vehicle */}
            <section className="py-24 max-w-7xl mx-auto px-4">
                <div className="flex flex-col md:flex-row items-center gap-16">
                    <motion.div className="md:w-1/2" {...fadeIn}>
                        <img src="/assets/images/research-development/740_1718787206image-connected-vehicle.png" alt="Smart Connection" className="w-full rounded-xl shadow-2xl" />
                    </motion.div>
                    <motion.div className="md:w-1/2 text-right" {...fadeIn}>
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Smart Connection<br />Vehicle</h2>
                        <p className="text-gray-600 leading-relaxed pl-8">
                            Integration of 5G, AI, and Big Data to create an intelligent cockpit and
                            connected driving ecosystem, seamlessly linking people, vehicles, and life.
                        </p>
                    </motion.div>
                </div>
            </section>

            {/* Magic Core Power */}
            <section className="py-24 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 mb-20 text-center">
                    <h2 className="text-6xl md:text-8xl font-black text-gray-200 uppercase tracking-widest mb-12">POWER</h2>
                </div>

                <div className="max-w-7xl mx-auto px-4 space-y-24">
                    {/* Engine 1 */}
                    <div className="flex flex-col md:flex-row items-center gap-12">
                        <div className="md:w-1/2">
                            <h3 className="text-3xl font-bold mb-4">Magic Core<br />Power Awarded<br /><span className="text-red-600">CHINA BEST<br />ENGINES</span></h3>
                            <p className="text-gray-600">
                                The Magic Core 1.5T engine has been recognized for its thermal efficiency,
                                performance, and fuel economy, setting a new benchmark in the industry.
                            </p>
                        </div>
                        <div className="md:w-1/2 flex justify-center">
                            <motion.img
                                src="/assets/images/research-development/351_1718787207engine1.png"
                                alt="Magic Core Engine"
                                className="max-w-sm w-full drop-shadow-2xl"
                                whileHover={{ scale: 1.05 }}
                            />
                        </div>
                    </div>

                    {/* Engine 2 */}
                    <div className="flex flex-col md:flex-row-reverse items-center gap-12">
                        <div className="md:w-1/2">
                            <h3 className="text-3xl font-bold mb-4">Awarded CHINA<br />BEST NEW<br />ENERGY VEHICLE<br /><span className="text-red-600">POWERTRAINS</span></h3>
                            <p className="text-gray-600">
                                Our advanced powertrain systems deliver exceptional efficiency and power,
                                driving the new energy revolution forward.
                            </p>
                        </div>
                        <div className="md:w-1/2 flex justify-center">
                            <motion.img
                                src="/assets/images/research-development/956_1718787207engine2.png"
                                alt="Powertrain"
                                className="max-w-sm w-full drop-shadow-2xl"
                                whileHover={{ scale: 1.05 }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* WHOM WE COOPERATE WITH - Strip */}
            <div className="bg-black text-white py-16 text-center">
                <h2 className="text-3xl font-bold uppercase tracking-widest mb-4">Whom We Cooperate With</h2>
                <div className="flex justify-center flex-wrap gap-8 opacity-70">
                    {/* Add partner logos if available or just text/placeholder */}
                    <span className="text-xl font-light">Global Technology Partners</span>
                </div>
            </div>

            {/* EIC Technology */}
            <section className="py-24 max-w-7xl mx-auto px-4">
                <div className="flex flex-col md:flex-row items-center gap-12">
                    <div className="md:w-1/2">
                        <h2 className="text-4xl font-bold mb-6">EIC<br />Technology</h2>
                        <p className="text-gray-600 mb-8">
                            Comprehensive Electric Drive, Battery, and Control technologies forming the
                            backbone of our NEV strategy.
                        </p>
                        <img src="/assets/images/research-development/eic-tech.png" alt="EIC Tech" className="w-full rounded-lg shadow-lg" />
                    </div>
                    <div className="md:w-1/2 relative">
                        {/* Intelligent Energy context */}
                        <div className="bg-gray-100 p-8 rounded-2xl md:mt-12">
                            <h3 className="text-2xl font-bold mb-4 text-center">Intelligent Energy</h3>
                            <img src="/assets/images/research-development/503_1718787208eic04.png" alt="Intelligent Energy" className="w-full" />
                        </div>
                    </div>
                </div>
            </section>

            {/* Swapping Station & Battery */}
            <section className="py-24 bg-white">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="mb-20">
                        <h2 className="text-3xl font-bold mb-8">Intelligent Battery Swapping Station</h2>
                        <div className="relative rounded-2xl overflow-hidden h-64 md:h-96">
                            <img src="/assets/images/research-development/756_1718787208image-swapping-station.png" alt="Swapping Station" className="w-full h-full object-cover" />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end p-8">
                                <p className="text-white text-lg">Rapid 3-minute battery swap technology</p>
                            </div>
                        </div>
                    </div>

                    <div className="mb-20">
                        <h2 className="text-3xl font-bold mb-8">Energy Storage Battery</h2>
                        <img src="/assets/images/research-development/256_1718787208battery01.png" alt="Energy Storage" className="w-full max-w-4xl mx-auto" />
                    </div>

                    <div className="flex flex-col gap-24">
                        <div className="flex flex-col md:flex-row items-center gap-12">
                            <div className="md:w-1/2">
                                <h2 className="text-3xl font-bold mb-6">Battery<br />Evaluation</h2>
                                <p className="text-gray-600 mb-8">
                                    Rigorous testing and verification standards ensuring battery safety,
                                    longevity, and performance under all conditions.
                                </p>
                            </div>
                            <div className="md:w-1/2">
                                <img src="/assets/images/research-development/846_1718787208battery02.png" alt="Battery Evaluation" className="w-full drop-shadow-xl" />
                            </div>
                        </div>

                        <div className="flex flex-col md:flex-row-reverse items-center gap-12">
                            <div className="md:w-1/2 text-right">
                                <h2 className="text-3xl font-bold mb-6">Battery Technology<br />Enhancement</h2>
                            </div>
                            <div className="md:w-1/2 flex justify-center">
                                <img src="/assets/images/research-development/277_1718787209battery-technology-enhancement.png" alt="Tech Enhancement" className="w-420 md:w-160 animate-spin-slow" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
};

export default ResearchDevelopmentPage;
